import React from 'react';

const avatarUrl = `${process.env.REACT_APP_API_STORAGE}`;

function Avatar({ src, alt, className = 'w-12 h-12', useRawSrc = false }) {
  const imgSrc = useRawSrc ? src : (src ? `${avatarUrl}/${src}` : '/avatar.png');
  return (
    <div className={`rounded-full border-2 border-gray-strong ${className}`}>
      <img src={imgSrc} alt={alt} title={alt} className="w-full h-full rounded-full" />
    </div>
  );
}

export default Avatar;
